// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2AFM5","cell":"ColumnAccessor_cell__3c2l3","firstCellAccent":"ColumnAccessor_firstCellAccent__evx1b"};